import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { SupportedCurrencies } from 'frontend-utils/utils/constants/currency-mapping-constants';

export default class ReviExchangeRate extends Model {
  [Type] = 'revi-exchange-rate' as const;

  @attr declare code: SupportedCurrencies;
  @attr('number') declare refValue: number;
}
